import { categories, hotRanking, siteMeta } from '@/mocks/homeContent';

const stats = [
  { value: '42', label: '已测评博主' },
  { value: '6', label: '持续更新榜单' },
  { value: '18', label: '收录避雷条目' },
];

export default function Hero() {
  const featured = hotRanking[0];
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-16">
      <div className="pointer-events-none absolute -right-20 -top-24 h-80 w-80 rounded-full bg-primary-100/70 blur-3xl" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -left-24 top-40 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl" aria-hidden="true"></div>

      <div className="container-x relative grid grid-cols-1 items-center gap-10 py-10 md:py-16 lg:grid-cols-[1.2fr_1fr] lg:gap-14">
        <div className="flex flex-col gap-5">
          <span className="chip w-fit bg-accent-100 text-accent-900">
            <span className="h-2 w-2 rounded-full bg-accent-500" aria-hidden="true"></span>
            {siteMeta.desc} · 更新于 {siteMeta.updatedAt}
          </span>

          <h1 className="font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            搭讪吃瓜
            <span className="mt-1 block text-xl font-bold text-primary-600 md:text-2xl">把搭讪博主，一个一个翻个明白</span>
          </h1>

          <p className="max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            我们不教你搭讪，我们帮你「看懂」教搭讪的人。测评盘点热门搭讪博主、持续更新搭讪博主排行、横向对比风格与实战表现，
            顺带把套路话术和翻车现场一起拆给你看，帮你快速锁定真正值得关注的社交表达内容创作者。
          </p>

          <div className="flex flex-wrap items-center gap-3">
            <a
              href="#rankings"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              看看本期热榜
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </a>
            <a
              href="#reviews"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
            >
              看深度测评
            </a>
          </div>

          <dl className="mt-2 grid w-fit grid-cols-3 gap-x-8 gap-y-1 border-t border-background-200 pt-4 sm:gap-x-12">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col">
                <dt className="order-2 text-xs text-foreground-600">{s.label}</dt>
                <dd className="order-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  {s.value}
                  <span className="ml-0.5 text-base text-accent-600">+</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <aside className="relative rounded-2xl border border-background-200 bg-background-50 p-5 shadow-soft">
          <div className="flex items-center justify-between">
            <span className="section-eyebrow">
              <i className="ri-fire-fill text-xs" aria-hidden="true"></i>
              本期头条聚焦
            </span>
            <a href="#rankings" className="text-xs font-semibold text-primary-600 hover:underline">
              完整榜单
            </a>
          </div>

          <div className="mt-4 flex items-start gap-4">
            <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-xl bg-primary-500 font-heading text-2xl font-black text-background-50">
              <span className="flex h-16 w-16 items-center justify-center">{featured.rank}</span>
            </div>
            <div className="flex flex-col gap-1.5">
              <h2 className="font-heading text-xl font-bold text-foreground-950">{featured.name}</h2>
              <div className="flex flex-wrap items-center gap-1.5">
                <span className="chip bg-background-100 text-foreground-700">{featured.platform}</span>
                <span className="chip bg-primary-100 text-primary-700">{featured.tag}</span>
                <span className="chip bg-accent-100 text-accent-800">{featured.fans} 粉丝</span>
              </div>
            </div>
          </div>

          <p className="mt-4 rounded-xl bg-secondary-50 px-4 py-3 text-sm leading-6 text-foreground-700">
            “{featured.summary}” 争议与热度齐飞，本期综合评分 <strong className="font-heading text-lg font-bold text-primary-600">{featured.score}</strong>。
          </p>

          <div className="mt-4 flex items-center justify-between rounded-xl border border-dashed border-accent-300 bg-accent-50/60 px-4 py-3">
            <span className="text-xs font-medium text-accent-900">
              <i className="ri-information-line mr-1" aria-hidden="true"></i>想看谁上谁下？点榜单跟编辑一起盯。
            </span>
          </div>
        </aside>
      </div>

      <div className="container-x pb-10 md:pb-14">
        <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => (
            <li key={c.name}>
              <a
                href={`#${c.target}`}
                className="group flex h-full flex-col gap-2 rounded-2xl border border-background-200 bg-background-50 p-4 transition hover:-translate-y-1 hover:border-primary-200 hover:shadow-lift"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-secondary-100 text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-sm font-bold text-foreground-950">{c.name}</span>
                <span className="text-xs leading-5 text-foreground-600">{c.desc}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}